/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TimeseriesValueState
 */
export interface TimeseriesValueState {
    /**
     * contains a State string when ValueType is STATE
     * @type {string}
     * @memberof TimeseriesValueState
     */
    valueState: string;
    /**
     * 
     * @type {string}
     * @memberof TimeseriesValueState
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof TimeseriesValueState
     */
    color: string;
}

/**
 * Check if a given object implements the TimeseriesValueState interface.
 */
export function instanceOfTimeseriesValueState(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "valueState" in value;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "color" in value;

    return isInstance;
}

export function TimeseriesValueStateFromJSON(json: any): TimeseriesValueState {
    return TimeseriesValueStateFromJSONTyped(json, false);
}

export function TimeseriesValueStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeseriesValueState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'valueState': json['valueState'],
        'label': json['label'],
        'color': json['color'],
    };
}

export function TimeseriesValueStateToJSON(value?: TimeseriesValueState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'valueState': value.valueState,
        'label': value.label,
        'color': value.color,
    };
}

